<template>
  <div>
    <div class="container" v-on:logout="logout">
      <div
        v-for="(serviceRow, index) in groupedServices"
        :key="index"
        class="row"
      >
        <div v-for="(svc, index) in serviceRow" :key="index" class="col-lg-4">
          <div
            class="card bg-light mb-3"
            style="max-width: 18rem; cursor: pointer;"
            @click="go2service(svc.serviceName, svc.url)"
          >
            <div class="card-header">{{ svc.title }}</div>
            <div class="card-body">
              <p class="card-text">{{ svc.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import axios from "axios";

export default {
  name: "Services",
  data: function () {
    return {
      services: [],
      openWindows: {},
    };
  },
  computed: {
    groupedServices() {
      return _.chunk(this.services, 3);
    },
  },
  methods: {
    go2service: function (service, url) {
      if (service in this.openWindows) {
        if (!this.openWindows[service].closed) {
          this.openWindows[service].focus();
          return;
        }
      }
      this.openWindows[service] = window.open(url, service);
      this.openWindows[service].focus();
    },
    logout: function () {
      /*eslint no-unused-vars: "off"*/
      _.forOwn(this.openWindows, function (service, key) {
        if (!service.closed) {
          service.close();
        }
      });
    },
  },
  beforeCreate() {
    axios.get("config.json").then((res) =>
    {
      this.services = res.data
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
